import { formatHuman, parse } from '@edtf-ts/core'

export const addDaysToDate = (date: Date, days: number) => {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days)
  return newDate
}

export const addMonthsToDate = (date: Date, months: number) => {
  const newDate = new Date(date)
  newDate.setMonth(newDate.getMonth() + months)
  return newDate
}

export const addYearsToDate = (date: Date, years: number) => {
  const newDate = new Date(date)
  newDate.setFullYear(newDate.getFullYear() + years)
  return newDate
}

const CURRENT_YEAR_FORMATTER = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'short',
})

const DIFFERENT_YEAR_FORMATTER = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

export const formatDate = (date: Date) =>
  date.getFullYear() === new Date().getFullYear() ? CURRENT_YEAR_FORMATTER.format(date) : DIFFERENT_YEAR_FORMATTER.format(date)

export const formatExpressiveDate = (date: Date) => {
  const now = new Date()

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const diffDays = Math.floor((today.getTime() - dateOnly.getTime()) / (1000 * 60 * 60 * 24))

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const time = `${hours}:${minutes}`

  if (diffDays === 0) {
    return `Today, ${time}`
  }
  if (diffDays === 1) {
    return `Yesterday, ${time}`
  }

  const day = date.getDate()
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const month = monthNames[date.getMonth()]
  return `${day} ${month}, ${time}`
}

export const getNextWeekStart = () => {
  const today = new Date()
  const day = today.getDay()
  const daysUntilNextWeek = (8 - day) % 7 || 7

  const nextWeekStart = addDaysToDate(today, daysUntilNextWeek)

  return {
    nextWeekStart,
    daysUntilNextWeek,
  }
}

export const formatEdtfString = (edtfString: string) => {
  try {
    const parsed = parse(edtfString)
    if (!parsed.success) {
      return edtfString
    }
    return formatHuman(parsed.value)
  } catch (e) {
    console.error(e)
  }
  return edtfString
}
